import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import MobileFooter from 'base/components/MobileFooter';
import ViewCart from 'menus/components/ViewCart';

class MenuPageFooter extends React.Component {
  static propTypes = {
    quantity: PropTypes.number,
    form: PropTypes.object,
    menuItem: PropTypes.object,
    location: PropTypes.object
  };

  render() {
    if (this.props.quantity === 0) {
      return null;
    }

    return (
      <MobileFooter>
        <ViewCart {...this.props} />
      </MobileFooter>
    );
  }
}

const mapStateToProps = state => ({
  subtotal: state.cart.subtotal,
  quantity: state.cart.quantity,
  form: state.form,
  menuItem: state.menuItem
});

export default withRouter(connect(mapStateToProps)(MenuPageFooter));
